import axios from 'axios';
import i18n from 'i18next';
import qs from 'qs';

const axiosOptions = {
    baseURL: `${process.env.REACT_APP_API_HOST}/`,
    headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'Accept-Language': i18n.language,
    },
    withCredentials: true,
};

const axiosInstance = axios.create(axiosOptions);

axiosInstance.interceptors.request.use((config) => {
    const token = localStorage.getItem('jwtToken');
    const companyId = JSON.parse(localStorage.getItem('company'))?.id;
    const baseHeaders = {
        ...config.headers,
        'Accept-Language': i18n.language,
        'Company-Id': companyId,
    };
    if (token) {
        return {
            ...config,
            headers: {
                ...baseHeaders,
                Authorization: `Bearer ${token}`,
            },
        };
    }

    return {
        ...config,
        headers: {
            ...baseHeaders,
        },
    };
});

const paramsSerializer = (params) => qs.stringify(params, { encode: false, arrayFormat: 'brackets' });

axiosInstance.interceptors.response.use((response) => {
    const authToken = response.headers['Set-Authorization'] || response.headers['set-authorization'];
    if (authToken) {
        localStorage.setItem('jwtToken', authToken);
    } else if (
        Object.prototype.hasOwnProperty.call(response.headers, 'Set-Authorization') ||
        Object.prototype.hasOwnProperty.call(response.headers, 'set-authorization')
    ) {
        localStorage.removeItem('jwtToken');
    }
    return response;
});

export { paramsSerializer };
export default axiosInstance;
